import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { assets } from '../data/catalog';
import supabase from '../supabase/supabase';
import './Footer.css';

const { FiFacebook, FiInstagram, FiMessageCircle } = FiIcons;

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const [shopCategories, setShopCategories] = useState([]);

  useEffect(() => {
    const loadCategories = async () => {
      const { data, error } = await supabase
        .from('product_categories_1750000004')
        .select('name')
        .eq('active', true)
        .order('sort_order')
        .limit(5);

      if (!error && data?.length) {
        setShopCategories(data.map((c) => c.name));
      }
    };

    loadCategories();
  }, []);

  const scrollToSection = (sectionId) => (event) => {
    event.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    } else {
      const element = document.getElementById(sectionId);
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="site-footer" id="footer">
      <div className="footer-promo-banner">
        <img
          src="https://media-manager-c.questera.ai/greta-media/29d79c4109d1c19c2e75790b8e50872c9a33c9d5ce79f6f43f60effe48b91ada6d4fe9244bdd866a6b5eb503d1d2a9a7/images/aW1hZ2UvcG5n/bfc957d2b28c355c2770399188059ff7.png"
          alt="Darshana botanical collection"
        />
      </div>
      <div className="footer-main section-shell home-container site-footer-main">
        <div className="footer-brand site-footer-brand">
          <img src={assets.darkLogo} alt="Darshana Global Enterprises" className="footer-logo" />
          <p>Premium Sri Lankan botanicals, thoughtfully prepared for modern wellness rituals.</p>
          <div className="socials site-footer-socials">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><SafeIcon icon={FiFacebook} /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><SafeIcon icon={FiInstagram} /></a>
            <a href="https://wa.me/" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><SafeIcon icon={FiMessageCircle} /></a>
          </div>
        </div>
        <div className="footer-column site-footer-column">
          <h4>Company</h4>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact Us</Link>
        </div>
        <div className="footer-column site-footer-column">
          <h4>Shop</h4>
          {shopCategories.length > 0 ? (
            shopCategories.map((catName) => (
              <Link key={catName} to={`/shop?category=${encodeURIComponent(catName)}`}>{catName}</Link>
            ))
          ) : (
            <Link to="/shop">All Products</Link>
          )}
        </div>
        <div className="footer-column site-footer-column">
          <h4>Support</h4>
          <Link to="/track">Track Order</Link>
          <a href="#footer">Shipping</a>
          <a href="#footer">Returns</a>
          <a href="#footer">Privacy Policy</a>
        </div>
      </div>
      <div className="footer-bottom site-footer-bottom">
        <div className="footer-gradient-line" />
        <span>© 2026 Darshana Global Enterprises (PVT) LTD</span>
      </div>
    </footer>
  );
}

export default Footer;